export default "__VITE_ASSET__BzD8YC3q__"